module.exports = __webpack_public_path__ + "images/mobile/home_feature_icons-b4617e3fbf0b66ba9d84f41dfd2f589e.png";